var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createContext, useContext } from 'react';
var shop = {
    language: 'en_US',
    name: '',
    currency: 'USD',
    currencySymbol: '$',
    code: '',
    logo: 'https://cdn.shopifycdn.net/s/files/1/0270/0315/8570/files/Guide_Giftlab_logo_3x_543f4692-1c4e-4e94-8db7-06284fe3f155_300x90.png',
    theme: { r: 255, g: 84, b: 62, a: 1 }
};
var dataContext = createContext({
    peopleNumber: 1,
    productType: 'mini-me',
    colors: [],
    selectedColor: [],
    images: [],
    shop: shop,
    peopleIndex: 0,
    canvasData: { current: [] },
    currentSide: 0,
    selectedSize: { id: '', name: '' },
    inputTextDataText: undefined,
    selectedRelatedProduct: [],
    backSideNewImage: {},
    hasBackSideUpload: false,
    EditPageNextElement: { current: null },
    imageDataFor3dPreview: '',
    setCurrentSide: function () { },
    setInputTextDataText: function () { },
    setBackSideNewImage: function () { },
    setPeopleIndex: function () { },
    setSelectedColor: function () { },
    setCurrentSize: function () { },
    setEditVisible: function () { },
    setSelectedRelatedProduct: function () { },
    setHasBackSideUpload: function () { },
    setViualizerPreviewVisible: function () { },
    setImageDataFor3dPreview: function () { }
});
var useData = function () {
    var value = useContext(dataContext);
    return __assign({}, value);
};
var Provide = dataContext.Provider;
export { Provide, useData };
